import { RestrictedAccountObjectFacade } from "../restricted-account-object/restricted-account-object.facade";
import { GroupApiFacade } from "./group.api-facade";
import { GroupStoreFacade } from "./group.store-facade";
import { Group } from "./group.model";

export class GroupFacade extends RestrictedAccountObjectFacade<Group, GroupApiFacade, GroupStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/group/group.facade.ts